import { render, staticRenderFns } from "./Detail-Purchase-Order.vue?vue&type=template&id=623f8098&scoped=true&"
import script from "./Detail-Purchase-Order.vue?vue&type=script&lang=js&"
export * from "./Detail-Purchase-Order.vue?vue&type=script&lang=js&"
import style0 from "./Detail-Purchase-Order.vue?vue&type=style&index=0&id=623f8098&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623f8098",
  null
  
)

export default component.exports